import React, { useState } from 'react';
import { useNavigate,  } from 'react-router-dom';

import OrdersSearchBar from '../components/OrdersSearchBar'
import OrdersList from '../components/OrdersList';
import ProgressBar from '../components/ProgressBar';


const Orders = () => {


    const [orders, setOrders] = useState([])
    const [progressBarVisible, setProgressBarVisible] = useState(false)
    const [statData, setStatData] = useState('')

    const updateOrders = (data) => setOrders(data)
    const updateStatData = (val) => setStatData(val)
    
    const [urlPage, setUrlPage] = useState(0)
    const updateUrlPage = (val) => setUrlPage(val)
    
    const navigate = useNavigate();
    const navigateToOrder = (order) => {
        navigate(`/orders/${order.id}`,  { state: { 'order': order, 'page':urlPage } }) 
    }


    return (
        <>
            <OrdersSearchBar 
                orders={orders}
                updateOrders={updateOrders} 
                statData={statData} 
                setProgressBarVisible={setProgressBarVisible}
                updateUrlPage={updateUrlPage}
                urlPage={urlPage}
                 />

            { progressBarVisible ? 
                <ProgressBar /> : 
                    <OrdersList orders={orders} updateStatData={updateStatData} navigateToOrder={navigateToOrder} updateUrlPage={updateUrlPage} urlPage={urlPage} />  
            }
            
        </>
    );
}

export default Orders;
